(() => {
  const STEP = 10;
  const MIN = 10;

  document.documentElement.setAttribute('data-qa10-loaded', 'true');

  function normalize(n) {
    n = parseInt(String(n || ''), 10);
    if (isNaN(n) || n < MIN) return MIN;
    return Math.max(MIN, Math.round(n / STEP) * STEP);
  }

  // Toast
  function toast(msg = 'Hinzugefügt') {
    let t = document.querySelector('.qa10-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'qa10-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => t.classList.remove('is-visible'), 1600);
  }

  // Lock gegen Doppel-Add
  function isBusy(form) {
    return form?.dataset?.qa10Busy === 'true';
  }
  function setBusy(form, state) {
    if (!form) return;
    form.dataset.qa10Busy = state ? 'true' : 'false';
  }

  async function ajaxAdd(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity })
    });

    if (!res.ok) {
      const err = await res.json().catch(() => null);
      console.error('QA10 add failed:', err || res.statusText);
      toast('Fehler beim Hinzufügen');
      return false;
    }

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    return true;
  }

  // Prestige Card-Forms erkennen
  function isCardAddForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    const action = (form.getAttribute('action') || '').toLowerCase();
    // action kann "/cart/add" oder "/cart/add?..." sein
    return action.startsWith('/cart/add');
  }

  function getVariantId(form) {
    return form.querySelector('input[name="id"]')?.value || null;
  }

  function setHiddenQty(form, qty) {
    let q = form.querySelector('input[name="quantity"]');
    if (!q) {
      q = document.createElement('input');
      q.type = 'hidden';
      q.name = 'quantity';
      form.appendChild(q);
    }
    q.value = String(qty);
  }

  function getQtyFromUIOrDefault(form) {
    const valEl = form.querySelector('[data-qa10-val]');
    if (valEl) return normalize(valEl.textContent);
    return MIN;
  }

  // 🔥 Theme-QuickAdd wirklich deaktivieren (damit nicht +10 extra passiert)
  function neutralizePrestige(form) {
    // 1) button darf NICHT submitten
    const btn = form.querySelector('.product-card__quick-add-button');
    if (btn && btn.getAttribute('type') !== 'button') btn.setAttribute('type', 'button');

    // 2) product-form custom element aushebeln (damit Prestige nicht zusätzlich addet)
    //    (wir lassen das form ansonsten in Ruhe)
    if (form.getAttribute('is') === 'product-form') {
      form.setAttribute('data-qa10-was-product-form', 'true');
      form.removeAttribute('is');
    }

    // 3) force_open_drawer etc. neutralisieren (falls vorhanden)
    const onSuccess = form.querySelector('input[name="on_success"]');
    if (onSuccess) onSuccess.value = '';
  }

  function ensureUI(form) {
    if (!isCardAddForm(form)) return;

    // UI schon da?
    if (form.querySelector('.qa10-qty')) {
      neutralizePrestige(form);
      return;
    }

    const addBtn = form.querySelector('.product-card__quick-add-button');
    if (!addBtn) return;

    form.classList.add('qa10-form');

    const qtyWrap = document.createElement('div');
    qtyWrap.className = 'qa10-qty';
    qtyWrap.innerHTML = `
      <button type="button" class="qa10-qty__btn" data-qa10-minus aria-label="Weniger">−</button>
      <span class="qa10-qty__val" data-qa10-val>10</span>
      <button type="button" class="qa10-qty__btn" data-qa10-plus aria-label="Mehr">+</button>
    `;

    addBtn.parentNode.insertBefore(qtyWrap, addBtn);

    setHiddenQty(form, MIN);

    // 🔥 ganz wichtig: Prestige-Handling ausschalten
    neutralizePrestige(form);
  }

  function init(root = document) {
    root.querySelectorAll('product-card form[action^="/cart/add"]').forEach(ensureUI);
  }

  // Stepper +/-
  document.addEventListener('click', (e) => {
    const minus = e.target.closest?.('[data-qa10-minus]');
    const plus = e.target.closest?.('[data-qa10-plus]');
    if (!minus && !plus) return;

    const form = e.target.closest?.('form[action^="/cart/add"]');
    if (!isCardAddForm(form)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const valEl = form.querySelector('[data-qa10-val]');
    if (!valEl) return;

    let current = normalize(valEl.textContent);
    current = plus ? current + STEP : Math.max(MIN, current - STEP);
    valEl.textContent = String(current);
    setHiddenQty(form, current);
  }, true);

  // Add-Button Click => AJAX add
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest?.('.product-card__quick-add-button');
    if (!btn) return;

    const form = btn.closest('form[action^="/cart/add"]');
    if (!isCardAddForm(form)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    ensureUI(form);
    neutralizePrestige(form);

    if (isBusy(form)) return;
    setBusy(form, true);

    const variantId = getVariantId(form);
    if (!variantId) {
      setBusy(form, false);
      return;
    }

    const qty = getQtyFromUIOrDefault(form);
    setHiddenQty(form, qty);

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    try {
      const ok = await ajaxAdd(variantId, qty);
      if (ok) toast(`Hinzugefügt (${qty})`);
    } finally {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      setBusy(form, false);
    }
  }, true);

  // Submit komplett blocken (falls trotzdem etwas submitten will)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = (form.getAttribute('action') || '').toLowerCase();
    if (!action.startsWith('/cart/add')) return;

    if (form.querySelector('[data-qa10-val]')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);

  // Nachladen (Filter/Infinite scroll)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('product-card') || node.querySelector?.('product-card')) init(node);
      }
    }
  });
  mo.observe(document.documentElement, { subtree: true, childList: true });

  init();
})();
